import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { ResultsPage } from '@results';

export const Route = createFileRoute('/_app/_admin/results')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.Results);
  },
  component: ResultsPage,
});
